/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { CittadinoServizioMensaConfigurazioneDTO } from '../model/models';
import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface GetConfigurazioneMensaCittadinoRequestParams {
    gestioneMenseServizioId: string;
}


export interface ConfigurazioneMensaCittadinoServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Configurazione del servizio mensa (vista cittadino, servizio-level).
     * Audience CITTADINO. Ritorna servizio_id, data_inizio, data_fine, tipo_pagamento, gestione_manuale, generazione_ricariche_abilitata (derivato da stato_ricarica_manuale: false &#x3D; generazione bollettino momentaneamente bloccata), orario_massimo_per_annullamento_pasto e assistenza_email del servizio risolto dall\&#39;header Gestione-Mense-Servizio-Id (NON richiede id_studente). Richiede una Pratica accettata sul servizio; servizio non accessibile → 404 privacy-preserving.
     * @endpoint get /api/v1/cittadino/servizi/mensa/configurazione
* @param requestParameters
     */
    getConfigurazioneMensaCittadino(requestParameters: GetConfigurazioneMensaCittadinoRequestParams, extraHttpRequestParams?: any): Observable<CittadinoServizioMensaConfigurazioneDTO>;

}
